import {Observable,Subject} from "rxjs";
import {ProgressHandler} from "./progress-handler";
import {Progression} from "@domain/progression/progression";

/**
 * Classe abstraite des handlers de suivi de l'avancement d'un traitement back
 *
 * @author Laurent Convert
 * @date 06/08/2025
 */
export abstract class AbstractProgressHandler implements ProgressHandler {
	/** Subject et son observable permettant de suivre la progression */
	protected progressSubject: Subject<Progression> = new Subject<Progression>();
	public progress$: Observable<Progression> = this.progressSubject.asObservable();

	/** Objet du suivi de la progression */
	protected progression: Progression;

	/**
	 * Initialisation de la progression
	 *
	 * @param progression Valeur initiale
	 */
	initState(progression: Progression) {
		this.progression = new Progression(progression);
	}

	/**
	 * Connexion au serveur et démarrage du suivi
	 *
	 * @param uuid Identifiant de la progression en cours
	 */
	abstract start(uuid: string): void;

	/**
	 * Arrêt du suivi et déconnexion du serveur
	 */
	abstract stop(): void;

	/**
	 * Handler déclenché lorsque la progression est complete.
	 * Ferme les observables associés.
	 */
	protected completeHandler() {
		//Arrêt du suivi
		this.stop();

		//Fermeture des observables
		this.progressSubject.complete();
	}

	/**
	 * Mise à jour du suivi de l'avancement d'après l'objet passé en paramètre
	 *
	 * @param progress Progression
	 * @param emit Permet d'émettre l'avancement ou non à chaque mise à jour
	 */
	update(progress: Progression,emit: boolean = true): void {
		//Mise à jour de la progression
		Object.assign(this.progression,progress);

		//Si émission
		if (emit) {
			//Émission de la progression
			this.emitProgress();
		}

		//Dans le cas où la progression est terminée
		if (progress.complete) {
			//Déclenchement du handler de fin
			this.completeHandler();
		}
	}

	/**
	 * Émission de la progression
	 */
	protected emitProgress(): void {
		//Calcul du pourcentage d'avancement
		this.progression.computeProgression();
		
		//Émission
		this.progressSubject.next(this.progression);
	}

	/**
	 * Retourne une copie de la progression courante
	 */
	public getProgression(): Progression {
		return Object.assign(new Progression(this.progression));
	}
}
